var map = {
	"./_grjs.png": "K7tS",
	"./_grry.png": "CDyp",
	"./_hjcg.png": "Rt2c",
	"./_jxxm.png": "YMiD",
	"./_kykt.png": "nhhM",
	"./_txbz.png": "hY/6",
	"./_zbjc.png": "DaBH",
	"./add.png": "MjSq",
	"./api.png": "8I+G",
	"./apiActive.png": "xU0/",
	"./default.png": "6i9z",
	"./del-1.png": "N30l",
	"./del.png": "IkV6",
	"./file-unknown.png": "HLqs",
	"./icon_douhao.png": "HBKl",
	"./icon_edit.png": "Hqnh",
	"./icon_girl.png": "b0Zd",
	"./icon_head.png": "IrNv",
	"./icon_honor_1.png": "YSRK",
	"./icon_honor_2.png": "BWyY",
	"./icon_honor_3.png": "fvIt",
	"./icon_man.png": "FDO6",
	"./icon_seat.png": "AqLz",
	"./icon_tx.png": "Fdni",
	"./kc-1.png": "PzBP",
	"./kc.png": "FwFL",
	"./kcfl.png": "05sV",
	"./kcflActive.png": "eTVw",
	"./kcgl.png": "6kct",
	"./kcglActive.png": "w7ej",
	"./management.png": "PNNN",
	"./managementActive.png": "tI4a",
	"./mech.png": "cTl5",
	"./mechActive.png": "LuXh",
	"./new-1.png": "CpKW",
	"./new.png": "otvV",
	"./no-material.png": "Wavy",
	"./onTrial.png": "N8zJ",
	"./onTrialActive.png": "ByYG",
	"./resoAll.png": "qMmD",
	"./resoAllActive.png": "M05/",
	"./resour.png": "hydB",
	"./resourActive.png": "gMhT",
	"./resource.png": "j1aq",
	"./resourceActive.png": "9sms",
	"./role.png": "rxY1",
	"./roleActive.png": "Ffub",
	"./score.png": "O3fr",
	"./scoreActive.png": "MKic",
	"./sj.png": "Xd7e",
	"./studentStatus.png": "bAui",
	"./studentStatusActive.png": "cTns",
	"./sureCommit.png": "rOTK",
	"./sygl.png": "V7fj",
	"./syglActive.png": "JyDo",
	"./teacher.png": "SL6o",
	"./teacherActive.png": "UNrI",
	"./user.png": "Snh9",
	"./userActive.png": "fbjr",
	"./weixue.png": "3wEZ",
	"./yiwancheng.png": "foYH",
	"./zaixue.png": "5+I2",
	"./zwnr.png": "OjuU"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "aB6U";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon ^\.\/.*\.png$
// module id = aB6U
// module chunks = 96